import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { TariffTypeService } from '../../../core/services/tariff/tariff-type/tariff-type.service'
import { ImportTariffModel } from '../../../core/models/tariff.model'
import { MatOption } from '@angular/material/core'
import { MatSelect, MatSelectChange } from '@angular/material/select'
import { MatButton, MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIcon, MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { ModalLegalEntityClientComponent } from '../../customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { TariffService } from '../../../core/services/tariff/tariff/tariff.service'
import { ProposalClientService } from '../../../core/services/proposal/proposal-client/proposal-client.service'
import { emailValidator } from '../../../shared/utils/email_validator'
import { MatListModule } from '@angular/material/list'
import { MatProgressBar } from '@angular/material/progress-bar'

@Component({
  selector: 'modal-message-email',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatOption,
    MatSelect,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressBar,
    MatDialogClose,
  ],
  templateUrl: './modal-message-email.component.html',
  styleUrl: './modal-message-email.component.scss',
  providers: [ProposalClientService],
  standalone: true,
})
export class ModalMessageEmailComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private proposalClientService: ProposalClientService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<ModalMessageEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {
    if (data.item) {
      this.item = data.item
    }
  }

  loading: boolean = true
  success: boolean = true
  choice: boolean = true

  item: any = {}
  infos: any = {}

  ngOnInit(): void {
    // this.sendEmail()
  }

  sendEmail(sendEmail: boolean = false) {
    this.choice = false
    const model = {
      enviarEmail: sendEmail ? 'S' : 'N',
      propostaId: this.item.id,
    }
    this.proposalClientService.sendProposalClientEmail(model).subscribe({
      next: (response: any) => {
        this.infos = response.data
        this.loading = false
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
        this.snackbar.errorRequest(err)
        this.loading = false
        this.success = false
      },
      complete: () => {},
    })
  }

  close() {
    this.dialogRef.close()
  }
}
